export default __webpack_public_path__ + "static/media/footerbg.6fe729b4.svg";